import { injectIntl } from "react-intl";
import { intlShape } from "../../shapes";
import ActionButton from "./ActionButton";

type OwnProps = {
  intl: intlShape;
  icon?: string;
  id?: string;
  target?: string;
  disabled?: boolean;
  label?: string;
  onClick?: () => void;
};

const defaultProps: Partial<OwnProps> = {
  icon: "icon-eh-edit",
};

type Props = OwnProps & typeof defaultProps;

function EditActionButton(props: Props) {
  return (
    <ActionButton
      {...props}
      defaultLabel={props.intl.formatMessage({ id: "button.edit" })}
    />
  );
}

EditActionButton.defaultProps = defaultProps;

export default injectIntl(EditActionButton);
